import { getMotibellDetail } from "lib/api/motibell/getMotibellDetail"
import { useQuery, QueryClient } from "@tanstack/react-query"
import { useEffect } from "react"

const useGetMotibellDetailQuery = (
  { showDailyQuiz, showDailyUserQuiz, motibellNo, showCapacity },
  options
) => {
  useEffect(() => {
    return function clear() {
      const queryClient = new QueryClient()
      queryClient.resetQueries(["motibell-detail", motibellNo], { exact: true }).catch(() => {})
    }
  }, [motibellNo])
  return useQuery(
    createKey(motibellNo),
    async () => {
      const response = await getMotibellDetail({
        showDailyUserQuiz,
        showDailyQuiz,
        motibellNo,
        showCapacity,
      })
      const { motibell } = response.data
      return motibell
    },
    {
      retry: 10,
      ...options,
    }
  )
}
const createKey = (motibellNo) => ["motibell-detail", motibellNo]
export default useGetMotibellDetailQuery
